import { MAX_DOWNPAYMENT_THRESHOLD } from '@makemydeal/dr-dash-components';

export const MIN_DOWN_PAYMENT = 0;

export const parseDownPayment = (raw: string): number | null => {
    const stripped = raw.replace(/[$,]/g, '').trim();
    if (stripped === '') return null;
    const parsed = parseInt(stripped, 10);
    if (!Number.isFinite(parsed) || parsed !== Number(stripped)) return null;
    if (parsed < MIN_DOWN_PAYMENT || parsed > MAX_DOWNPAYMENT_THRESHOLD) return null;
    return parsed;
};
